// Module
var code = "<form action=\"{{gscc.formAction}}\" method=\"get\"><input type=\"hidden\" name=\"type\" value=\"global\"/><input type=\"hidden\" name=\"q\" ng-value=\"gscc.searchValue\"/></form>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/commons/components/kp-global-search/kp-global-search.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;